<script setup>
import { ref, reactive, computed } from "vue";
import { queryDictData } from "@/api/common";
import ImageUpload from "../plantConfig/imageUpload.vue";
import {
  queryLocationById,
  insertLocation,
  updateLocation,
} from "@/api/location";
import { ElMessage } from "element-plus";

const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 弹窗类型
const dialogType = ref("add");

const titleType = reactive({
  add: "新增",
  edit: "编辑",
});

// api
const requestApi = reactive({
  add: insertLocation,
  edit: updateLocation,
});

// 表单ref
const ruleRef = ref(null);

// 类型列表
const areaTypeList = ref([]);

// 弹窗loading
const loading = ref(false);

// 表单
const formData = reactive({
  id: null,
  name: null,
  areaType: null,
  remark: null,
  logo: null,
  ancestors: null,
  parentId: null,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "区域名称不可为空", trigger: "blur" }],
  areaType: [{ required: true, message: "请选择类型", trigger: "blur" }],
});

// 头像选择回调
const logoPromise = (file) => {
  formData.logo = file.reduceUrl;
};

// 获取字典数据
const getLocationType = () => {
  queryDictData("sys_location_type").then((res) => {
    areaTypeList.value = res.data;
  });
};

// 获取详情数据
const getLocationInfo = (id) => {
  queryLocationById(id).then((res) => {
    if (JSON.stringify(res.data) !== "{}") {
      for (const key in formData) {
        formData[key] = res.data[key];
      }
    }
  });
};

// 点击保存
const formSubmit = () => {
  ruleRef.value?.validate((valid) => {
    if (valid) {
      requestApi[dialogType.value](formData).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
          visible.value = false;
          emits("afterSave");
        }
      });
    }
  });
};

// 弹窗打开
const handleDialogOpen = (data, type) => {
  getLocationType();
  dialogType.value = type;
  visible.value = true;
  ruleRef.value?.resetFields();
  formData.id = null;
  formData.parentId = data.id;
  if (data.parentId == null) {
    formData.ancestors = "0";
  } else {
    const arr = data.ancestors ? data.ancestors.split(",") : [];
    arr.push(data.id);
    formData.ancestors = arr.join(",");
  }
  if (type == "edit" && data.id) {
    getLocationInfo(data.id);
  }
};

// 函数暴露给父组件调用
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    :title="titleType[dialogType]"
    v-model="visible"
    width="50%"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleRef"
      :model="formData"
      :rules="rules"
      label-width="80px"
      v-loading="loading"
    >
      <el-form-item label="Logo" prop="logo">
        <image-upload :url="formData.logo" @fileUpload="logoPromise" />
      </el-form-item>
      <el-form-item label="区域名称" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="请输入区域位置名称"
          :disabled="dialogType == 'edit'"
        />
      </el-form-item>
      <el-form-item label="类型" prop="areaType">
        <el-select v-model="formData.areaType" style="width: 100%">
          <el-option
            v-for="item in areaTypeList"
            :key="item.id"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="2"
          show-word-limit
          :maxlength="200"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="formSubmit()"> 保存 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped></style>
